export const ENDS_WITH_SLASHES_PATTERN = /[\\/]+$/u;
export const NUMBER_STR_PATTERN = /^\d+$/u;
export const PHONE_NUMBER_PATTERN = /^0(\d{9}|\d{10})$/u;
